import axios from 'axios';
import { Message } from 'element-ui';

function ErrorMsgShow(msg, sec = 5000, type = 'error') {
  Message({ message: msg, type, duration: sec });
}

// 创建axios实例
const service = axios.create({
  baseURL: process.env.BASE_API, // api 的 base_url
  timeout: 30000, // 请求超时时间
});

// request拦截器
service.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem('Authorization');
    if (token) {
      // 让每个请求携带自定义token 请根据实际情况自行修改
      config.headers.authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    console.warn('请求错误', error); // for debug
    Promise.reject(error);
  },
);

// response 拦截器
service.interceptors.response.use(
  (response) => {
    const res = response.data;
    // 接口报错处理
    if (typeof res === 'string') {
      // 处理非json数据格式报错处理，比如二进制流
      return res;
    }
    if (res.error && res.error.length) {
      ErrorMsgShow(res.error);
      return Promise.reject(res);
    }
    if (res.msg && res.msg.length) {
      ErrorMsgShow(res.msg, 5000, 'success');
      return res;
    }
    return response.data;
  },
  (error) => {
    console.warn(`接口错误 ${error}`); // for debug
    const { data } = error.response;
    if (data && data.error) {
      ErrorMsgShow(`${data.error}`);
    } else {
      ErrorMsgShow('网络繁忙，请稍后再试');
    }
    return Promise.reject(error);
  },
);

export default service;
